module.exports = __webpack_public_path__ + "img/profitability7.26637853.png";